import { db } from '../../firebase/config';

// Haalt de rijen van één matrixvraag op voor de verplichte-vraag-controle.
//
// Eigen bestand omdat twee schermen hem delen (TopLevelFields en Section) en
// omdat de controle zelf (`requiredFieldsBlock`) puur moet blijven: die krijgt
// de lader als parameter en is daardoor zonder Firestore te toetsen.
//
// Een directe read, langs de centrale zachte-verwijderfilter heen —
// `matrixRowsComplete` filtert `Deleted` zelf.
// AI-CONTEXT: See docs/pitfalls.md#database-missing-compagnyid-on-fresh-fetch

/**
 * @param {string} fieldID - `MatrixQuestionRows.Field`
 * @returns {Promise<Array<object>>} De rijen; gooit door als de read faalt
 */
const loadMatrixRows = async (fieldID) => {
    const snap = await db.collection('MatrixQuestionRows')
        .where('Field', '==', fieldID)
        .get();

    return snap.docs.map((doc) => doc.data());
};

export default loadMatrixRows;
